module.exports = __webpack_public_path__ + "static/img/9.5349011.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/9.png
// module id = hMwo
// module chunks = 0